import PropTypes from 'prop-types';
import React from 'react';
import BillingIcon from 'src/svgs/tool/billing.svg';
import ChannelLineupIcon from 'src/svgs/tool/channel-lineup.svg';
import HomePortalIcon from 'src/svgs/tool/home-portal.svg';
import MovingIcon from 'src/svgs/tool/moving.svg';
import PairRemoteIcon from 'src/svgs/tool/pair-remote.svg';
import PremiumIcon from 'src/svgs/tool/premium.svg';
import RestartGatewayIcon from 'src/svgs/tool/restart-gateway.svg';
import SpeedTestIcon from 'src/svgs/tool/speed-test.svg';
import SystemRefreshIcon from 'src/svgs/tool/system-refresh.svg';
import UpdateWifiIcon from 'src/svgs/tool/update-wifi.svg';
import WifiIcon from 'src/svgs/tool/internet-wifi.svg';

export const Icon = ({icon}) => {
  switch (icon) {
    case 'billing': return <BillingIcon />;
    case 'channel-lineup': return <ChannelLineupIcon />;
    case 'home-portal': return <HomePortalIcon />;
    case 'moving': return <MovingIcon />;
    case 'pair-remote': return <PairRemoteIcon />;
    case 'premium': return <PremiumIcon />;
    case 'restart-gateway': return <RestartGatewayIcon />;
    case 'speed-test': return <SpeedTestIcon />;
    case 'system-refresh': return <SystemRefreshIcon />;
    case 'update-wifi': return <UpdateWifiIcon />;
    case 'wifi': return <WifiIcon />;
    default: return null;
  }
};

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
};
